import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { LicenseQuery } from '@eggplant/types'

interface Props {
  params?: LicenseQuery
  onSuccess: () => void
  children?: () => void
}

const PatchAiLicenseRequest = ({
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/licenses`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='patch'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default PatchAiLicenseRequest
